import React from 'react';
import PropTypes from 'prop-types';
import Utils from '../AVPlayer/utils';

const Duration = ({ currentPosition, totalLength }) => (
    <div className="duration">
        <span>{Utils.durationToText(currentPosition)}</span><span>{Utils.durationToText(totalLength)}</span>
    </div>
);

Duration.propTypes = {
    currentPosition: PropTypes.number.isRequired,
    totalLength: PropTypes.number.isRequired
};

export default Duration;
